import * as actionTypes from 'redux/actions/action-types.js'

const initialState = {
    users: {
        lastFetch: 0,
        loading: false,
    },
    tenants: {
        lastFetch: 0,
        loading: false,
    },
    needsToPay: false,
}

const awsut = (state = initialState, action) => {
    const { data, error, type } = action || {}
    switch (type) {
        // case actionTypes.STORE_INIT:
        //     return {
        //         ...initialState,
        //     }
        case actionTypes.AWS_UTT_REQUEST_SUCCESS: //tenants
            return {
                ...state,
                tenants: {
                    ...state.tenants,
                    lastFetch: Date.now(),
                    loading: false,
                    data: data,
                },
            }
        case actionTypes.AWS_UTT_REQUEST:
            return {
                ...state,
                tenants: {
                    ...state.tenants,
                    loading: true,
                },
            }
        case actionTypes.AWS_UTT_REQUEST_FAILURE:
            return {
                ...state,
                tenants: {
                    ...state.tenants,
                    loading: false,
                    error: error,
                    lastError: Date.now(),
                },
            }
        case actionTypes.AWS_UTU_REQUEST_SUCCESS: //users in that tenant
            const accStatus = data?.accountStatus
            localStorage.setItem(`${data.alias}.account`, JSON.stringify(data))
            return {
                ...state,
                users: {
                    ...state.users,
                    loading: false,
                    lastFetch: Date.now(),
                    data: data,
                },
                needsToPay: accStatus !== 'trialing' && accStatus !== 'trial_expired' && accStatus !== 'active' && accStatus !== 'past_due' && accStatus !== 'ending_soon',
            }
        case actionTypes.AWS_UTU_REQUEST:
            return {
                ...state,
                users: {
                    ...state.users,
                    loading: true,
                },
            }
        case actionTypes.AWS_UTU_REQUEST_FAILURE:
            return {
                ...state,
                users: {
                    ...state.tusers,
                    loading: false,
                    error: error,
                    lastError: Date.now(),
                },
                needsToPay: false,
            }
        default: {
            return state
        }
    }
}

export default awsut
